import {
  API_BASE_URL
} from 'shared/utils/Constants';

export const SEARCH_ACCOUNTS_URL = () => {
  return `${API_BASE_URL}/v2/portal/accounts`;
}

export const ACCOUNTS_URL = () => {
  return `${API_BASE_URL}/accounts`;
}

export const ACCOUNT_LOGO_URL = accountId => {
  return `${API_BASE_URL}/accounts/${accountId}/logo`;
}

export const SWITCH_ACCOUNT_URL = () => {
  return `${API_BASE_URL}/user/account`;
}

export const USER_AVATAR_URL = userId => {
  return `${API_BASE_URL}/users/${userId}/avatar`;
}

export const JOBS_URL = () => {
  return `${API_BASE_URL}/portal/jobs`;
}

export const SIMPLE_JOBS_URL = (page, perPage) => {
  // Portal param introduces more than is currently necessary for simple job lists at the cost of performance
  // return `${API_BASE_URL}/portal/jobs?portal=true`;
  return `${API_BASE_URL}/portal/jobs?page=${page}&per_page=${perPage}`;
}

export const JOB_URL = id => {
  return `${API_BASE_URL}/portal/jobs/${id}`;
}

export const JOB_MOMENTS_URL = (id, page, perPage) => {
  return `${API_BASE_URL}/portal/jobs/${id}/moments?page=${page}&per_page=${perPage}`;
}

export const DELETE_DEFAULT_MOMENT = (jobId, momentId) => {
  return `${API_BASE_URL}/portal/jobs/${jobId}/moments/${momentId}`;
}

export const KIOSK_URL = id => {
  return `${API_BASE_URL}/kiosks/${id}`;
}

export const KIOSKS_URL = () => {
  return `${API_BASE_URL}/kiosks`;
}

export const SEARCH_JOBS_URL = () => {
  return `${API_BASE_URL}/v2/portal/jobs`;
}

export const CUSTOMERS_URL = () => {
  return `${API_BASE_URL}/portal/customers`;
}

export const CUSTOMER_URL = id => {
  return `${API_BASE_URL}/portal/customers/${id}`;
}

export const CUSTOMER_MOMENTS_URL = (id, page, perPage) => {
  return `${API_BASE_URL}/portal/customers/${id}/moments?page=${page}&per_page=${perPage}`;
}

export const CUSTOMER_MOMENTS_DELETE = (id) => {
  return `${API_BASE_URL}/photographer/customer/${id}/remove_moments`;
}

export const CUSTOMER_NOTIFY_URL = () => {
  return `${API_BASE_URL}/portal/customers/notify`;
}

export const SEARCH_CUSTOMERS_URL = () => {
  return `${API_BASE_URL}/v2/portal/customers`;
}

export const SEARCH_GUESTS_URL = () => {
  return `${API_BASE_URL}/v2/portal/guests`;
}

export const VISIT_URL = id => {
  return `${API_BASE_URL}/club_med_visits/${id}`;
}

export const MOMENTS_URL = () => {
  return `${API_BASE_URL}/portal/moments`;
}

export const MOMENT_URL = id => {
  return `${API_BASE_URL}/moment/${id}`;
}

export const MOMENT_FILE_URL = () => {
  return `${API_BASE_URL}/moment/file`;
}

export const MOMENT_IMAGE_URL = (momentId, scale = 'p') => {
  return `${API_BASE_URL}/moment/url?id=${momentId}&scale=${scale}&show_all=true&accept_original=true`;
}

export const SEARCH_MOMENTS_URL = () => {
  return `${API_BASE_URL}/v2/portal/moments`;
}

export const TOGGLE_PREMIUM_MOMENT_URL = id => {
  return `${API_BASE_URL}/moments/${id}/premium`
}

export const STORY_MOMENTS_DOWNLOAD = story_id => {
  return `${API_BASE_URL}/stories/${story_id}/download`;
}

export const JOB_CONFIGS_URL = () => {
  return `${API_BASE_URL}/job_configs`;
}

export const JOB_CONFIG_URL = id => {
  return `${API_BASE_URL}/job_configs/${id}`;
}

export const SEARCH_JOB_CONFIGS_URL = () => {
  return `${API_BASE_URL}/v2/portal/job_configs`;
}

export const JOB_CONFIG_TEMPLATES_URL = () => {
  return `${API_BASE_URL}/job_config_templates`;
}

export const JOB_CONFIG_TEMPLATE_URL = id => {
  return `${API_BASE_URL}/job_config_templates/${id}`;
}

export const SEARCH_JOB_CONFIG_TEMPLATES_URL = () => {
  return `${API_BASE_URL}/v2/portal/job_config_templates`;
}

export const MEMBERS_URL = () => {
  return `${API_BASE_URL}/portal/members`;
}

export const MEMBER_URL = id => {
  return `${API_BASE_URL}/portal/members/${id}`;
}

export const SEARCH_MEMBERS_URL = () => {
  return `${API_BASE_URL}/v2/portal/members`;
}

export const KIOSKS_BY_ACCOUNT_URL = accountId => {
  return `${API_BASE_URL}/kiosks?account_id=${accountId}`;
}

export const PORTAL_CONTENT_PROVIDERS_URL = () => {
  return `${API_BASE_URL}/portal/accounts/providers`;
}

export const CONTENT_PROVIDERS_URL = accountId => {
  return `${API_BASE_URL}/accounts/${accountId}/providers`;
}

export const CONTENT_PROVIDER_URL = (accountId, providerId) => {
  return `${API_BASE_URL}/accounts/${accountId}/providers/${providerId}`;
}

export const CONTENT_PROVIDER_SEARCH_TOKEN_URL = (accountId, token) => {
  return `${API_BASE_URL}/accounts/${accountId}/providers/search?access_token=${token}`;
}

export const SEARCH_CONTENT_PROVIDERS_URL = () => {
  return `${API_BASE_URL}/v2/portal/providers`;
}

export const SEARCH_KIOSK_URL = () => {
  return `${API_BASE_URL}/v2/portal/kiosks`;
}

export const KIOSK_LOCALE_URL = (kioskId, localeId) => {
  if (localeId) {
    return `${API_BASE_URL}/kiosks/${kioskId}/locales/${localeId}`;
  } else {
    return `${API_BASE_URL}/kiosks/${kioskId}/locales`;
  }
}

export const KIOSK_LOCALE_UPLOAD_ASSETS_URL = (kioskId, localeId, assetType, contentType) => {
  return `${API_BASE_URL}/kiosks/${kioskId}/locales/${localeId}/${assetType}/upload?content_type=` + contentType;
}

// export const ACCOUNT_PRINT_SIZES_URL = accountId => {
//   return `${API_BASE_URL}/accounts/${accountId}/print_sizes`;
// }

export const KIOSK_PRINT_SIZES_URL = kioskId => {
  return `${API_BASE_URL}/kiosks/${kioskId}/print_sizes`;
}

export const GET_PRINT_SIZES_URL = kioskId => {
  return `${API_BASE_URL}/kiosks/${kioskId}/print_sizes/populate`;
}

export const KIOSK_BACKGROUND_URL = (token, locale) => {
  return `${API_BASE_URL}/kiosk/${token}/background?locale=${locale}&t=${Date.now()}`;
}

export const KIOSK_LOGO_URL = (token, locale) => {
  return `${API_BASE_URL}/kiosk/${token}/logo?locale=${locale}&t=${Date.now()}`;
}

export const SEARCH_MARKETING_URL = () => {
  return `${API_BASE_URL}/v2/portal/marketing`;
}

export const MARKETING_URL = (marketingId) => {
  return `${API_BASE_URL}/marketing/${marketingId}`;
}

export const MARKETINGS_URL = () => {
  return `${API_BASE_URL}/marketing`;
}

export const MARKETING_IMAGE_UPLOAD_URL = (marketingId, contentType) => {
  return `${API_BASE_URL}/marketing/${marketingId}/image/upload?content_type=${contentType}`;
}

export const SEARCH_PURCHASES_URL = () => {
  return `${API_BASE_URL}/v2/portal/purchases`;
}

export const SEARCH_SALES_REPORT_URL = () => {
  return `${API_BASE_URL}/v2/portal/reports/sales`;
}

export const SEARCH_ANALYTICS_REPORT_URL = () => {
  return `${API_BASE_URL}/v2/portal/reports/analytics`;
}

export const SEARCH_PHOTOGRAPHER_HOURLY_REPORT_URL = () => {
  return `${API_BASE_URL}/v2/portal/reports/photog_hourly`;
}

export const PRODUCT_BACKGROUNDS_URL = (accountId, productId) => {
  return `${API_BASE_URL}/accounts/${accountId}/backgrounds?product_id=${productId}`;
}

export const PRODUCT_BACKGROUND_URL = (accountId) => {
  return `${API_BASE_URL}/accounts/${accountId}/backgrounds`;
}

export const BACKGROUND_ASPECT_URL = (accountId, backgroundId, aspectId) => {
  return `${API_BASE_URL}/accounts/${accountId}/backgrounds/${backgroundId}/aspect/${aspectId}`
}

export const OVERLAY_ASPECT_URL = (productId, overlayId, aspectId) => {
  return `${API_BASE_URL}/products/${productId}/overlays/${overlayId}/aspect/${aspectId}`
}

export const MOMENT_UPLOAD_URL = (momentId, type, asJson) => {
  return `${API_BASE_URL}/moment/upload/${momentId}?type=${type}&as_json=${asJson}`;
}

export const PRODUCT_OVERLAYS_URL = (productId) => {
  return `${API_BASE_URL}/products/${productId}/overlays`;
}

export const PRODUCT_KNOCKOUT_PAIRS_URL = (accountId, productId) => {
  return `${API_BASE_URL}/accounts/${accountId}/products/${productId}/knockout_pairs`;
}

export const PRODUCT_KNOCKOUT_PAIR_URL = (accountId, productId, knockOutId) => {
  return `${API_BASE_URL}/accounts/${accountId}/products/${productId}/knockout_pairs/${knockOutId}`;
}

export const PRODUCT_BACKGROUND_DELETE_URL = (accountId, productId, backgroundId) => {
  return `${API_BASE_URL}/accounts/${accountId}/products/${productId}/backgrounds/${backgroundId}`;
}

export const PRODUCT_OVERLAY_DELETE_URL = (productId, overlayId) => {
  return `${API_BASE_URL}/products/${productId}/overlays/${overlayId}`;
}

export const GRID_STATE_URL = (accountId, resource) => {
  return `${API_BASE_URL}/portal/grid_states/${accountId}/${resource}`;
}

export const UPLOADS_URL = accountId => {
  return `${API_BASE_URL}/accounts/${accountId}/upload`;
}

export const CURRENT_UPLOAD_URL = accountId => {
  return `${API_BASE_URL}/accounts/${accountId}/upload/current`;
}

export const UPLOAD_URL = (accountId, id) => {
  return `${API_BASE_URL}/accounts/${accountId}/upload/${id}`;
}

export const SEARCH_UPLOADS_URL = () => {
  return `${API_BASE_URL}/portal/search/uploads`;
}

export const SEARCH_MOMENT_UPLOADS_URL = () => {
  return `${API_BASE_URL}/portal/search/moment_uploads`;
}

export const SEARCH_BILLINGS_URL = () => {
  return `${API_BASE_URL}/v2/portal/billing`;
}

export const SEARCH_ACCOUNT_BILLINGS_URL = () => {
  return `${API_BASE_URL}/v2/portal/account_billing`;
}

export const SEARCH_ACCOUNT_PRICINGS_URL = () => {
  return `${API_BASE_URL}/v2/portal/account_pricing`;
}

export const BILLINGS_URL = () => {
  return `${API_BASE_URL}/billing`;
}

export const BILLING_URL = (id) => {
  return `${API_BASE_URL}/billing/${id}`;
}

export const ACCOUNT_BILLINGS_URL = () => {
  return `${API_BASE_URL}/billing/account_billing`;
}

export const ACCOUNT_BILLING_URL = (id) => {
  return `${API_BASE_URL}/billing/account_billing/${id}`;
}

export const ACCOUNT_PRICINGS_URL = () => {
  return `${API_BASE_URL}/billing/account_pricing`;
}

export const ACCOUNT_PRICING_URL = (id) => {
  return `${API_BASE_URL}/billing/account_pricing/${id}`;
}

export const ACCOUNT_INVITE_USER_URL = (accountId) => {
  return `${API_BASE_URL}/accounts/${accountId}/user/invite`;
}

export const BILLING_REPORT_URL = () => {
  return `${API_BASE_URL}/billing/billing_report`;
}

export const SEARCH_BILLING_EXPORT_SCHEDULE_URL = () => {
  return `${API_BASE_URL}/v2/portal/billing/export_schedule`;
}

export const BILLING_EXPORT_SCHEDULES_URL = () => {
  return `${API_BASE_URL}/billing/export_schedule`;
}

export const BILLING_EXPORT_SCHEDULE_URL = (id) => {
  return `${API_BASE_URL}/billing/export_schedule/${id}`;
}

export const ACCOUNT_LOGO_UPLOAD_URL = (accountId, contentType) => {
  return `${API_BASE_URL}/accounts/${accountId}/logo/upload?type=${contentType}`;
}

export const GLOBAL_SEARCH_URL = (accountId, query) => {
  return `${API_BASE_URL}/accounts/${accountId}/search?q=${query}`;
}

export const TAGS_URL = () => {
  return `${API_BASE_URL}/portal/search/tags`;
}

export const DISCOUNTS_CODE_URL = (productId) => {
  return `${API_BASE_URL}/products/${productId}/discount_code`;
}

export const DISCOUNT_CODE_URL = (productId, id) => {
  return `${API_BASE_URL}/products/${productId}/discount_code/${id}`;
}

export const PRICINGS_TIERS_URL = (productId) => {
  return `${API_BASE_URL}/products/${productId}/pricing_tiers`;
}

export const PRICING_TIERS_URL = (productId, id) => {
  return `${API_BASE_URL}/products/${productId}/pricing_tiers/${id}`;
}

export const FEATURE_FLAGS_URL = () => {
  return `${API_BASE_URL}/wheel/feature_flags`;
}

export const JOB_QRCODE_URL = (jobId, download = false) => {
  return `${API_BASE_URL}/access_code/page/job_qr_code?job_id=${jobId}&download=${download}`;
}

export const JOB_QRCODE_TEMPLATE_URL = jobId => {
  return `${API_BASE_URL}/portal/jobs/${jobId}/qrtemplates/get_url`;
}

export const JOB_QRCODE_TEMPLATE_UPLOAD_URL = (jobId, contentType) => {
  return `${API_BASE_URL}/portal/jobs/${jobId}/qrtemplates/upload?content_type=${contentType}`;
}

export const QR_GEN_TEMPLATES_URL = (jobId) => {
  return `${API_BASE_URL}/qr_codes/${jobId}/templates`;
}

export const QR_REMOVE_TEMPLATES_URL = (jobId) => {
  return `${API_BASE_URL}/qr_codes/${jobId}/templates/remove`;
}

export const QR_GEN_URL = (jobId) => {
  return `${API_BASE_URL}/qr_codes/${jobId}`;
}

export const ACCOUNT_WATERMARK_URL = (accountId) => {
  return `${API_BASE_URL}/accounts/${accountId}/watermark`;
}

export const ACCOUNT_WATERMARK_UPLOAD_URL = (accountId, contentType) => {
  return `${API_BASE_URL}/accounts/${accountId}/watermark/upload?type=${contentType}`;
}

export const SEARCH_CATALOGS_URL = () => {
  return `${API_BASE_URL}/v2/portal/catalogs`;
}

export const ACCEPT_INVITE_URL = () => {
  return `${API_BASE_URL}/accounts/accept`;
}

export const SEARCH_ACCESS_CODE_PAGES_URL = () => {
  return `${API_BASE_URL}/v2/portal/access_code_pages`;
}

export const ACCESS_CODE_PAGES_URL = () => {
  return `${API_BASE_URL}/access_code/page`;
}

export const ACCESS_CODE_PAGE_URL = id => {
  return `${API_BASE_URL}/access_code/page/${id}`;
}

export const ACCESS_CODE_PAGE_LOGO_UPLOAD_URL = (id, contentType) => {
  return `${API_BASE_URL}/access_code/page/${id}/logo/upload?type=${contentType}`;
}

export const ACCESS_CODE_PAGE_BACKGROUND_UPLOAD_URL = (id, contentType) => {
  return `${API_BASE_URL}/access_code/page/${id}/background/upload?type=${contentType}`;
}

export const ACCESS_CODE_PAGE_VIDEO_UPLOAD_URL = (id, contentType) => {
  return `${API_BASE_URL}/access_code/page/${id}/video/upload?type=${contentType}`;
}

export const ACCESS_CODE_PAGE_FAVICON_UPLOAD_URL = (id, contentType) => {
  return `${API_BASE_URL}/access_code/page/${id}/favicon/upload?type=${contentType}`;
}

export const ACCESS_CODE_PAGE_METADATA_URL = (page_id) => {
  return `${API_BASE_URL}/access_code/meta_data/${page_id}`;
}

export const WHEEL_ACCOUNT_USERS = (id) => {
  return `${API_BASE_URL}/wheel/accountusers?account_id=${id}`;
}

export const WHEEL_GET_ACCOUNT_USER = (email, userId) => {
  return `${API_BASE_URL}/wheel/su?email=${email}&user_id=${userId}`;
}

export const WHEEL_BECOME_ACCOUNT_USER = (email, userId) => {
  return `${API_BASE_URL}/wheel/su?email=${email}&switch=true&user_id=${userId}`;
}

export const ACCOUNT_USERS_URL = (accountId) => {
  return `${API_BASE_URL}/accounts/${accountId}/users`;
}

export const ACCOUNT_USER_URL = (accountId, userId) => {
  return `${API_BASE_URL}/accounts/${accountId}/users/${userId}`;
}

export const SEARCH_GDPR_URL = params => {
  const {
    email,
    user_id
  } = params;

  let url = new URL(`${API_BASE_URL}/wheel/gdpr`);

  if (email) {
    url.searchParams.set('email', email);
  }

  if (user_id) {
    url.searchParams.set('user_id', user_id);
  }

  return url.href;
}

export const CREATE_GDPR_URL = () => {
  return `${API_BASE_URL}/gdpr/requests`;
}

export const UPDATE_GDPR_URL = uuid => {
  return `${API_BASE_URL}/gdpr/requests/${uuid}`;
}

export const SEARCH_DAILY_READ_REPORT_URL = () => {
  return `${API_BASE_URL}/reports/daily_read_report`;
}

export const WHEEL_CHANGE_PASSWORD_URL = (password, userId) => {
  return `${API_BASE_URL}/wheel/passwd?passwd=${password}&user_id=${userId}`;
}

export const SEARCH_WORKER_STATUS_REPORT_URL = () => {
  return `${API_BASE_URL}/reports/worker_status_report`;
}

// GDPR request types
export const INFORMATION_REQUEST_TYPE = 0;
export const RECTIFY_REQUEST_TYPE = 1;
export const DELETE_REQUEST_TYPE = 2;

export const PAGE_SIZE = 100;
export const DOWNLOAD_TYPES = ["Cards", "Pages", "CSV only"]
export const STATUS = ["Failed", "Created", "Processing", "Complete", "Finalizing"]
export const DISCOUNT_TYPE_PERCENT = 0;
export const DISCOUNT_TYPE_AMOUNT = 1;

// these constants correspond with the server side values
export const OPERATOR_KEY = '_operator';
export const AND_OPERATOR = 'AND';
export const OR_OPERATOR = 'OR';

export const STANDARD_ACCOUNT_TYPE = 2;
export const GFCREW_ACCOUNT_TYPE = 3;
export const SUBJOB_ACCOUNT_TYPE = 4;
export const CLUBMED_ACCOUNT_TYPE = 5;
export const HPX_ACCOUNT_TYPE = 6;
export const HAWKS_ACCOUNT_TYPE = 7;
export const KIOSK_ACCOUNT_TYPE = 8;

export const MOSTRECENT_MOMENT_ORDER = 0;
export const CHRONOLOGICAL_MOMENT_ORDER = 1;
export const FILENAME_MOMENT_ORDER = 2;

export const CARDS_DOWNLOAD_TYPE = 0;
export const PAGES_DOWNLOAD_TYPE = 1;
export const CSV_DOWNLOAD_TYPE = 2;

export const SUPER_USER_ACCOUNT_ID = -1;

export const CURRENCY_OPTIONS = [
  { label: '$ USD', value: 'USD' },
  { label: '$ CAD', value: 'CAD' },
  { label: '$ MXN', value: 'MXN' },
  { label: '$ DOP', value: 'DOP' },
  { label: '$ MOP', value: 'MOP' },
  { label: '£ GBP', value: 'GBP' },
  { label: '€ EUR', value: 'EUR' },
  { label: '$ AUD', value: 'AUD' },
  { label: 'RM MYR', value: 'MYR' },
  { label: '$ BBD', value: 'BBD' },
  { label: 'R$ BRL', value: 'BRL' },
  { label: 'zł PLN', value: 'PLN' },
  { label: 'د.إ AED', value: 'AED' },
  { label: 'Ft HUF', value: 'HUF' },
  { label: 'Kč CZK', value: 'CZK' },
]

export const IMAGE_PRODUCT_TYPE = 0;
export const VIDEO_PRODUCT_TYPE = 1;
export const VIDEO_STORY_PRODUCT_TYPE = 2;
export const BACKGROUND_PRODUCT_TYPE = 3;
export const THE_36PIX_PRODUCT_TYPE = 4;
export const UPGRDIO_PRODUCT_TYPE = 5;
export const WEB_CART_PACKAGE_PRODUCT_TYPE = 6;
export const OVERLAY_PRODUCT_TYPE = 7;
export const KNOCKOUT_PRODUCT_TYPE = 8;

export const BACKGROUND_GRAVITY_LEFT = 0;
export const BACKGROUND_GRAVITY_CENTER = 1;
export const BACKGROUND_GRAVITY_RIGHT = 2;
